/**
 * SiteAndexBack API
 * API de Base
 *
 * OpenAPI spec version: v1
 * Contact: amahmoudi@aiventu.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { Formulaire } from '../model/formulaire';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { Constant } from 'src/app/shared/_constants/constant';


@Injectable()
export class FormulaireService {

    protected basePath = Constant.ApiRoot;
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public _delete(id: string, observe?: 'body', reportProgress?: boolean): Observable<Formulaire>;
    public _delete(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Formulaire>>;
    public _delete(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Formulaire>>;
    public _delete(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling _delete.');
        }

        let headers = this.defaultHeaders;

        var token: string ='Bearer '+ localStorage.getItem('MyApp_token').replace(/\"/gi,'');
        if (token != undefined) {
            headers = headers.set('Authorization', token);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<Formulaire>(`${this.basePath}/api/formulaire/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public get(observe?: 'body', reportProgress?: boolean): Observable<Array<Formulaire>>;
    public get(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Formulaire>>>;
    public get(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Formulaire>>>;
    public get(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        var token: string ='Bearer '+ localStorage.getItem('MyApp_token').replace(/\"/gi,'');
        if (token != undefined) {
            headers = headers.set('Authorization', token);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<Formulaire>>(`${this.basePath}/api/formulaire`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public get_1(id: string, observe?: 'body', reportProgress?: boolean): Observable<Formulaire>;
    public get_1(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Formulaire>>;
    public get_1(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Formulaire>>;
    public get_1(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling get_1.');
        }

        let headers = this.defaultHeaders;

        var token: string ='Bearer '+ localStorage.getItem('MyApp_token').replace(/\"/gi,'');
        if (token != undefined) {
            headers = headers.set('Authorization', token);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Formulaire>(`${this.basePath}/api/formulaire/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param Email 
     * @param FormulaireId 
     * @param Nom 
     * @param Prenom 
     * @param NumeroTel 
     * @param Entreprise 
     * @param Fonction 
     * @param Objet 
     * @param Message 
     * @param Page_PageId 
     * @param Page_Resume 
     * @param Page_Ordre 
     * @param Page_Categorie_CategorieId 
     * @param Page_Categorie_Nom 
     * @param Page_Categorie_Description 
     * @param Page_Categorie_Article 
     * @param Page_Categorie_Page 
     * @param Page_Categorie_Children 
     * @param Page_Categorie_SUPCategorieId 
     * @param Page_Categorie_Parent_CategorieId 
     * @param Page_Categorie_Parent_Nom 
     * @param Page_Categorie_Parent_Description 
     * @param Page_Categorie_Parent_Article 
     * @param Page_Categorie_Parent_Page 
     * @param Page_Categorie_Parent_Children 
     * @param Page_Categorie_Parent_SUPCategorieId 
     * @param Page_Categorie_Parent_Parent 
     * @param Page_Categorie_Parent_UtilisateurCreation 
     * @param Page_Categorie_Parent_UtilisateurModification 
     * @param Page_Categorie_Parent_DateCreation 
     * @param Page_Categorie_Parent_DateModification 
     * @param Page_Categorie_UtilisateurCreation 
     * @param Page_Categorie_UtilisateurModification 
     * @param Page_Categorie_DateCreation 
     * @param Page_Categorie_DateModification 
     * @param Page_Modele_Id 
     * @param Page_Modele_Name 
     * @param Page_Modele_NbTitre 
     * @param Page_Modele_NbParagraphe 
     * @param Page_Modele_NbImage 
     * @param Page_Modele_UtilisateurCreation 
     * @param Page_Modele_UtilisateurModification 
     * @param Page_Modele_DateCreation 
     * @param Page_Modele_DateModification 
     * @param Page_estPublie 
     * @param Page_Formulaire 
     * @param Page_Titres 
     * @param Page_Paragraphes 
     * @param Page_Fichiers 
     * @param Page_UtilisateurCreation 
     * @param Page_UtilisateurModification 
     * @param Page_DateCreation 
     * @param Page_DateModification 
     * @param PageId 
     * @param UtilisateurCreation 
     * @param UtilisateurModification 
     * @param DateCreation 
     * @param DateModification 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public post(Email: string, FormulaireId?: string, Nom?: string, Prenom?: string, NumeroTel?: string, Entreprise?: string, Fonction?: string, Objet?: string, Message?: string, Page_PageId?: string, Page_Resume?: string, Page_Ordre?: string, Page_Categorie_CategorieId?: string, Page_Categorie_Nom?: string, Page_Categorie_Description?: string, Page_Categorie_Article?: Array<any>, Page_Categorie_Page?: Array<any>, Page_Categorie_Children?: Array<any>, Page_Categorie_SUPCategorieId?: string, Page_Categorie_Parent_CategorieId?: string, Page_Categorie_Parent_Nom?: string, Page_Categorie_Parent_Description?: string, Page_Categorie_Parent_Article?: Array<any>, Page_Categorie_Parent_Page?: Array<any>, Page_Categorie_Parent_Children?: Array<any>, Page_Categorie_Parent_SUPCategorieId?: string, Page_Categorie_Parent_Parent?: { [key: string]: string; }, Page_Categorie_Parent_UtilisateurCreation?: string, Page_Categorie_Parent_UtilisateurModification?: string, Page_Categorie_Parent_DateCreation?: Date, Page_Categorie_Parent_DateModification?: Date, Page_Categorie_UtilisateurCreation?: string, Page_Categorie_UtilisateurModification?: string, Page_Categorie_DateCreation?: Date, Page_Categorie_DateModification?: Date, Page_Modele_Id?: string, Page_Modele_Name?: string, Page_Modele_NbTitre?: number, Page_Modele_NbParagraphe?: number, Page_Modele_NbImage?: number, Page_Modele_UtilisateurCreation?: string, Page_Modele_UtilisateurModification?: string, Page_Modele_DateCreation?: Date, Page_Modele_DateModification?: Date, Page_estPublie?: boolean, Page_Formulaire?: Array<any>, Page_Titres?: Array<any>, Page_Paragraphes?: Array<any>, Page_Fichiers?: Array<any>, Page_UtilisateurCreation?: string, Page_UtilisateurModification?: string, Page_DateCreation?: Date, Page_DateModification?: Date, PageId?: string, UtilisateurCreation?: string, UtilisateurModification?: string, DateCreation?: Date, DateModification?: Date, observe?: 'body', reportProgress?: boolean): Observable<Formulaire>;
    public post(Email: string, FormulaireId?: string, Nom?: string, Prenom?: string, NumeroTel?: string, Entreprise?: string, Fonction?: string, Objet?: string, Message?: string, Page_PageId?: string, Page_Resume?: string, Page_Ordre?: string, Page_Categorie_CategorieId?: string, Page_Categorie_Nom?: string, Page_Categorie_Description?: string, Page_Categorie_Article?: Array<any>, Page_Categorie_Page?: Array<any>, Page_Categorie_Children?: Array<any>, Page_Categorie_SUPCategorieId?: string, Page_Categorie_Parent_CategorieId?: string, Page_Categorie_Parent_Nom?: string, Page_Categorie_Parent_Description?: string, Page_Categorie_Parent_Article?: Array<any>, Page_Categorie_Parent_Page?: Array<any>, Page_Categorie_Parent_Children?: Array<any>, Page_Categorie_Parent_SUPCategorieId?: string, Page_Categorie_Parent_Parent?: { [key: string]: string; }, Page_Categorie_Parent_UtilisateurCreation?: string, Page_Categorie_Parent_UtilisateurModification?: string, Page_Categorie_Parent_DateCreation?: Date, Page_Categorie_Parent_DateModification?: Date, Page_Categorie_UtilisateurCreation?: string, Page_Categorie_UtilisateurModification?: string, Page_Categorie_DateCreation?: Date, Page_Categorie_DateModification?: Date, Page_Modele_Id?: string, Page_Modele_Name?: string, Page_Modele_NbTitre?: number, Page_Modele_NbParagraphe?: number, Page_Modele_NbImage?: number, Page_Modele_UtilisateurCreation?: string, Page_Modele_UtilisateurModification?: string, Page_Modele_DateCreation?: Date, Page_Modele_DateModification?: Date, Page_estPublie?: boolean, Page_Formulaire?: Array<any>, Page_Titres?: Array<any>, Page_Paragraphes?: Array<any>, Page_Fichiers?: Array<any>, Page_UtilisateurCreation?: string, Page_UtilisateurModification?: string, Page_DateCreation?: Date, Page_DateModification?: Date, PageId?: string, UtilisateurCreation?: string, UtilisateurModification?: string, DateCreation?: Date, DateModification?: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Formulaire>>;
    public post(Email: string, FormulaireId?: string, Nom?: string, Prenom?: string, NumeroTel?: string, Entreprise?: string, Fonction?: string, Objet?: string, Message?: string, Page_PageId?: string, Page_Resume?: string, Page_Ordre?: string, Page_Categorie_CategorieId?: string, Page_Categorie_Nom?: string, Page_Categorie_Description?: string, Page_Categorie_Article?: Array<any>, Page_Categorie_Page?: Array<any>, Page_Categorie_Children?: Array<any>, Page_Categorie_SUPCategorieId?: string, Page_Categorie_Parent_CategorieId?: string, Page_Categorie_Parent_Nom?: string, Page_Categorie_Parent_Description?: string, Page_Categorie_Parent_Article?: Array<any>, Page_Categorie_Parent_Page?: Array<any>, Page_Categorie_Parent_Children?: Array<any>, Page_Categorie_Parent_SUPCategorieId?: string, Page_Categorie_Parent_Parent?: { [key: string]: string; }, Page_Categorie_Parent_UtilisateurCreation?: string, Page_Categorie_Parent_UtilisateurModification?: string, Page_Categorie_Parent_DateCreation?: Date, Page_Categorie_Parent_DateModification?: Date, Page_Categorie_UtilisateurCreation?: string, Page_Categorie_UtilisateurModification?: string, Page_Categorie_DateCreation?: Date, Page_Categorie_DateModification?: Date, Page_Modele_Id?: string, Page_Modele_Name?: string, Page_Modele_NbTitre?: number, Page_Modele_NbParagraphe?: number, Page_Modele_NbImage?: number, Page_Modele_UtilisateurCreation?: string, Page_Modele_UtilisateurModification?: string, Page_Modele_DateCreation?: Date, Page_Modele_DateModification?: Date, Page_estPublie?: boolean, Page_Formulaire?: Array<any>, Page_Titres?: Array<any>, Page_Paragraphes?: Array<any>, Page_Fichiers?: Array<any>, Page_UtilisateurCreation?: string, Page_UtilisateurModification?: string, Page_DateCreation?: Date, Page_DateModification?: Date, PageId?: string, UtilisateurCreation?: string, UtilisateurModification?: string, DateCreation?: Date, DateModification?: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Formulaire>>;
    public post(Email: string, FormulaireId?: string, Nom?: string, Prenom?: string, NumeroTel?: string, Entreprise?: string, Fonction?: string, Objet?: string, Message?: string, Page_PageId?: string, Page_Resume?: string, Page_Ordre?: string, Page_Categorie_CategorieId?: string, Page_Categorie_Nom?: string, Page_Categorie_Description?: string, Page_Categorie_Article?: Array<any>, Page_Categorie_Page?: Array<any>, Page_Categorie_Children?: Array<any>, Page_Categorie_SUPCategorieId?: string, Page_Categorie_Parent_CategorieId?: string, Page_Categorie_Parent_Nom?: string, Page_Categorie_Parent_Description?: string, Page_Categorie_Parent_Article?: Array<any>, Page_Categorie_Parent_Page?: Array<any>, Page_Categorie_Parent_Children?: Array<any>, Page_Categorie_Parent_SUPCategorieId?: string, Page_Categorie_Parent_Parent?: { [key: string]: string; }, Page_Categorie_Parent_UtilisateurCreation?: string, Page_Categorie_Parent_UtilisateurModification?: string, Page_Categorie_Parent_DateCreation?: Date, Page_Categorie_Parent_DateModification?: Date, Page_Categorie_UtilisateurCreation?: string, Page_Categorie_UtilisateurModification?: string, Page_Categorie_DateCreation?: Date, Page_Categorie_DateModification?: Date, Page_Modele_Id?: string, Page_Modele_Name?: string, Page_Modele_NbTitre?: number, Page_Modele_NbParagraphe?: number, Page_Modele_NbImage?: number, Page_Modele_UtilisateurCreation?: string, Page_Modele_UtilisateurModification?: string, Page_Modele_DateCreation?: Date, Page_Modele_DateModification?: Date, Page_estPublie?: boolean, Page_Formulaire?: Array<any>, Page_Titres?: Array<any>, Page_Paragraphes?: Array<any>, Page_Fichiers?: Array<any>, Page_UtilisateurCreation?: string, Page_UtilisateurModification?: string, Page_DateCreation?: Date, Page_DateModification?: Date, PageId?: string, UtilisateurCreation?: string, UtilisateurModification?: string, DateCreation?: Date, DateModification?: Date, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (Email === null || Email === undefined) {
            throw new Error('Required parameter Email was null or undefined when calling post.');
        }


























































        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (FormulaireId !== undefined && FormulaireId !== null) {
            queryParameters = queryParameters.set('FormulaireId', <any>FormulaireId);
        }
        if (Nom !== undefined && Nom !== null) {
            queryParameters = queryParameters.set('Nom', <any>Nom);
        }
        if (Prenom !== undefined && Prenom !== null) {
            queryParameters = queryParameters.set('Prenom', <any>Prenom);
        }
        if (Email !== undefined && Email !== null) {
            queryParameters = queryParameters.set('Email', <any>Email);
        }
        if (NumeroTel !== undefined && NumeroTel !== null) {
            queryParameters = queryParameters.set('NumeroTel', <any>NumeroTel);
        }
        if (Entreprise !== undefined && Entreprise !== null) {
            queryParameters = queryParameters.set('Entreprise', <any>Entreprise);
        }
        if (Fonction !== undefined && Fonction !== null) {
            queryParameters = queryParameters.set('Fonction', <any>Fonction);
        }
        if (Objet !== undefined && Objet !== null) {
            queryParameters = queryParameters.set('Objet', <any>Objet);
        }
        if (Message !== undefined && Message !== null) {
            queryParameters = queryParameters.set('Message', <any>Message);
        }
        if (Page_PageId !== undefined && Page_PageId !== null) {
            queryParameters = queryParameters.set('Page.PageId', <any>Page_PageId);
        }
        if (Page_Resume !== undefined && Page_Resume !== null) {
            queryParameters = queryParameters.set('Page.Resume', <any>Page_Resume);
        }
        if (Page_Ordre !== undefined && Page_Ordre !== null) {
            queryParameters = queryParameters.set('Page.Ordre', <any>Page_Ordre);
        }
        if (Page_Categorie_CategorieId !== undefined && Page_Categorie_CategorieId !== null) {
            queryParameters = queryParameters.set('Page.Categorie.CategorieId', <any>Page_Categorie_CategorieId);
        }
        if (Page_Categorie_Nom !== undefined && Page_Categorie_Nom !== null) {
            queryParameters = queryParameters.set('Page.Categorie.Nom', <any>Page_Categorie_Nom);
        }
        if (Page_Categorie_Description !== undefined && Page_Categorie_Description !== null) {
            queryParameters = queryParameters.set('Page.Categorie.Description', <any>Page_Categorie_Description);
        }
        if (Page_Categorie_Article) {
            Page_Categorie_Article.forEach((element) => {
                queryParameters = queryParameters.append('Page.Categorie.Article', <any>element);
            })
        }
        if (Page_Categorie_Page) {
            Page_Categorie_Page.forEach((element) => {
                queryParameters = queryParameters.append('Page.Categorie.Page', <any>element);
            })
        }
        if (Page_Categorie_Children) {
            Page_Categorie_Children.forEach((element) => {
                queryParameters = queryParameters.append('Page.Categorie.Children', <any>element);
            })
        }
        if (Page_Categorie_SUPCategorieId !== undefined && Page_Categorie_SUPCategorieId !== null) {
            queryParameters = queryParameters.set('Page.Categorie.SUPCategorieId', <any>Page_Categorie_SUPCategorieId);
        }
        if (Page_Categorie_Parent_CategorieId !== undefined && Page_Categorie_Parent_CategorieId !== null) {
            queryParameters = queryParameters.set('Page.Categorie.Parent.CategorieId', <any>Page_Categorie_Parent_CategorieId);
        }
        if (Page_Categorie_Parent_Nom !== undefined && Page_Categorie_Parent_Nom !== null) {
            queryParameters = queryParameters.set('Page.Categorie.Parent.Nom', <any>Page_Categorie_Parent_Nom);
        }
        if (Page_Categorie_Parent_Description !== undefined && Page_Categorie_Parent_Description !== null) {
            queryParameters = queryParameters.set('Page.Categorie.Parent.Description', <any>Page_Categorie_Parent_Description);
        }
        if (Page_Categorie_Parent_Article) {
            Page_Categorie_Parent_Article.forEach((element) => {
                queryParameters = queryParameters.append('Page.Categorie.Parent.Article', <any>element);
            })
        }
        if (Page_Categorie_Parent_Page) {
            Page_Categorie_Parent_Page.forEach((element) => {
                queryParameters = queryParameters.append('Page.Categorie.Parent.Page', <any>element);
            })
        }
        if (Page_Categorie_Parent_Children) {
            Page_Categorie_Parent_Children.forEach((element) => {
                queryParameters = queryParameters.append('Page.Categorie.Parent.Children', <any>element);
            })
        }
        if (Page_Categorie_Parent_SUPCategorieId !== undefined && Page_Categorie_Parent_SUPCategorieId !== null) {
            queryParameters = queryParameters.set('Page.Categorie.Parent.SUPCategorieId', <any>Page_Categorie_Parent_SUPCategorieId);
        }
        if (Page_Categorie_Parent_Parent !== undefined && Page_Categorie_Parent_Parent !== null) {
            queryParameters = queryParameters.set('Page.Categorie.Parent.Parent', <any>Page_Categorie_Parent_Parent);
        }
        if (Page_Categorie_Parent_UtilisateurCreation !== undefined && Page_Categorie_Parent_UtilisateurCreation !== null) {
            queryParameters = queryParameters.set('Page.Categorie.Parent.UtilisateurCreation', <any>Page_Categorie_Parent_UtilisateurCreation);
        }
        if (Page_Categorie_Parent_UtilisateurModification !== undefined && Page_Categorie_Parent_UtilisateurModification !== null) {
            queryParameters = queryParameters.set('Page.Categorie.Parent.UtilisateurModification', <any>Page_Categorie_Parent_UtilisateurModification);
        }
        if (Page_Categorie_Parent_DateCreation !== undefined && Page_Categorie_Parent_DateCreation !== null) {
            queryParameters = queryParameters.set('Page.Categorie.Parent.DateCreation', <any>Page_Categorie_Parent_DateCreation.toISOString());
        }
        if (Page_Categorie_Parent_DateModification !== undefined && Page_Categorie_Parent_DateModification !== null) {
            queryParameters = queryParameters.set('Page.Categorie.Parent.DateModification', <any>Page_Categorie_Parent_DateModification.toISOString());
        }
        if (Page_Categorie_UtilisateurCreation !== undefined && Page_Categorie_UtilisateurCreation !== null) {
            queryParameters = queryParameters.set('Page.Categorie.UtilisateurCreation', <any>Page_Categorie_UtilisateurCreation);
        }
        if (Page_Categorie_UtilisateurModification !== undefined && Page_Categorie_UtilisateurModification !== null) {
            queryParameters = queryParameters.set('Page.Categorie.UtilisateurModification', <any>Page_Categorie_UtilisateurModification);
        }
        if (Page_Categorie_DateCreation !== undefined && Page_Categorie_DateCreation !== null) {
            queryParameters = queryParameters.set('Page.Categorie.DateCreation', <any>Page_Categorie_DateCreation.toISOString());
        }
        if (Page_Categorie_DateModification !== undefined && Page_Categorie_DateModification !== null) {
            queryParameters = queryParameters.set('Page.Categorie.DateModification', <any>Page_Categorie_DateModification.toISOString());
        }
        if (Page_Modele_Id !== undefined && Page_Modele_Id !== null) {
            queryParameters = queryParameters.set('Page.Modele.Id', <any>Page_Modele_Id);
        }
        if (Page_Modele_Name !== undefined && Page_Modele_Name !== null) {
            queryParameters = queryParameters.set('Page.Modele.Name', <any>Page_Modele_Name);
        }
        if (Page_Modele_NbTitre !== undefined && Page_Modele_NbTitre !== null) {
            queryParameters = queryParameters.set('Page.Modele.NbTitre', <any>Page_Modele_NbTitre);
        }
        if (Page_Modele_NbParagraphe !== undefined && Page_Modele_NbParagraphe !== null) {
            queryParameters = queryParameters.set('Page.Modele.NbParagraphe', <any>Page_Modele_NbParagraphe);
        }
        if (Page_Modele_NbImage !== undefined && Page_Modele_NbImage !== null) {
            queryParameters = queryParameters.set('Page.Modele.NbImage', <any>Page_Modele_NbImage);
        }
        if (Page_Modele_UtilisateurCreation !== undefined && Page_Modele_UtilisateurCreation !== null) {
            queryParameters = queryParameters.set('Page.Modele.UtilisateurCreation', <any>Page_Modele_UtilisateurCreation);
        }
        if (Page_Modele_UtilisateurModification !== undefined && Page_Modele_UtilisateurModification !== null) {
            queryParameters = queryParameters.set('Page.Modele.UtilisateurModification', <any>Page_Modele_UtilisateurModification);
        }
        if (Page_Modele_DateCreation !== undefined && Page_Modele_DateCreation !== null) {
            queryParameters = queryParameters.set('Page.Modele.DateCreation', <any>Page_Modele_DateCreation.toISOString());
        }
        if (Page_Modele_DateModification !== undefined && Page_Modele_DateModification !== null) {
            queryParameters = queryParameters.set('Page.Modele.DateModification', <any>Page_Modele_DateModification.toISOString());
        }
        if (Page_estPublie !== undefined && Page_estPublie !== null) {
            queryParameters = queryParameters.set('Page.estPublie', <any>Page_estPublie);
        }
        if (Page_Formulaire) {
            Page_Formulaire.forEach((element) => {
                queryParameters = queryParameters.append('Page.Formulaire', <any>element);
            })
        }
        if (Page_Titres) {
            Page_Titres.forEach((element) => {
                queryParameters = queryParameters.append('Page.Titres', <any>element);
            })
        }
        if (Page_Paragraphes) {
            Page_Paragraphes.forEach((element) => {
                queryParameters = queryParameters.append('Page.Paragraphes', <any>element);
            })
        }
        if (Page_Fichiers) {
            Page_Fichiers.forEach((element) => {
                queryParameters = queryParameters.append('Page.Fichiers', <any>element);
            })
        }
        if (Page_UtilisateurCreation !== undefined && Page_UtilisateurCreation !== null) {
            queryParameters = queryParameters.set('Page.UtilisateurCreation', <any>Page_UtilisateurCreation);
        }
        if (Page_UtilisateurModification !== undefined && Page_UtilisateurModification !== null) {
            queryParameters = queryParameters.set('Page.UtilisateurModification', <any>Page_UtilisateurModification);
        }
        if (Page_DateCreation !== undefined && Page_DateCreation !== null) {
            queryParameters = queryParameters.set('Page.DateCreation', <any>Page_DateCreation.toISOString());
        }
        if (Page_DateModification !== undefined && Page_DateModification !== null) {
            queryParameters = queryParameters.set('Page.DateModification', <any>Page_DateModification.toISOString());
        }
        if (PageId !== undefined && PageId !== null) {
            queryParameters = queryParameters.set('PageId', <any>PageId);
        }
        if (UtilisateurCreation !== undefined && UtilisateurCreation !== null) {
            queryParameters = queryParameters.set('UtilisateurCreation', <any>UtilisateurCreation);
        }
        if (UtilisateurModification !== undefined && UtilisateurModification !== null) {
            queryParameters = queryParameters.set('UtilisateurModification', <any>UtilisateurModification);
        }
        if (DateCreation !== undefined && DateCreation !== null) {
            queryParameters = queryParameters.set('DateCreation', <any>DateCreation.toISOString());
        }
        if (DateModification !== undefined && DateModification !== null) {
            queryParameters = queryParameters.set('DateModification', <any>DateModification.toISOString());
        }

        let headers = this.defaultHeaders;

        var token: string ='Bearer '+ localStorage.getItem('MyApp_token').replace(/\"/gi,'');
        if (token != undefined) {
            headers = headers.set('Authorization', token);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<Formulaire>(`${this.basePath}/api/formulaire`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param Email 
     * @param FormulaireId 
     * @param Nom 
     * @param Prenom 
     * @param NumeroTel 
     * @param Entreprise 
     * @param Fonction 
     * @param Objet 
     * @param Message 
     * @param Page_PageId 
     * @param Page_Resume 
     * @param Page_Ordre 
     * @param Page_Categorie_CategorieId 
     * @param Page_Categorie_Nom 
     * @param Page_Categorie_Description 
     * @param Page_Categorie_Article 
     * @param Page_Categorie_Page 
     * @param Page_Categorie_Children 
     * @param Page_Categorie_SUPCategorieId 
     * @param Page_Categorie_Parent_CategorieId 
     * @param Page_Categorie_Parent_Nom 
     * @param Page_Categorie_Parent_Description 
     * @param Page_Categorie_Parent_Article 
     * @param Page_Categorie_Parent_Page 
     * @param Page_Categorie_Parent_Children 
     * @param Page_Categorie_Parent_SUPCategorieId 
     * @param Page_Categorie_Parent_Parent 
     * @param Page_Categorie_Parent_UtilisateurCreation 
     * @param Page_Categorie_Parent_UtilisateurModification 
     * @param Page_Categorie_Parent_DateCreation 
     * @param Page_Categorie_Parent_DateModification 
     * @param Page_Categorie_UtilisateurCreation 
     * @param Page_Categorie_UtilisateurModification 
     * @param Page_Categorie_DateCreation 
     * @param Page_Categorie_DateModification 
     * @param Page_Modele_Id 
     * @param Page_Modele_Name 
     * @param Page_Modele_NbTitre 
     * @param Page_Modele_NbParagraphe 
     * @param Page_Modele_NbImage 
     * @param Page_Modele_UtilisateurCreation 
     * @param Page_Modele_UtilisateurModification 
     * @param Page_Modele_DateCreation 
     * @param Page_Modele_DateModification 
     * @param Page_estPublie 
     * @param Page_Formulaire 
     * @param Page_Titres 
     * @param Page_Paragraphes 
     * @param Page_Fichiers 
     * @param Page_UtilisateurCreation 
     * @param Page_UtilisateurModification 
     * @param Page_DateCreation 
     * @param Page_DateModification 
     * @param PageId 
     * @param UtilisateurCreation 
     * @param UtilisateurModification 
     * @param DateCreation 
     * @param DateModification 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public put(id: string, Email: string, FormulaireId?: string, Nom?: string, Prenom?: string, NumeroTel?: string, Entreprise?: string, Fonction?: string, Objet?: string, Message?: string, Page_PageId?: string, Page_Resume?: string, Page_Ordre?: string, Page_Categorie_CategorieId?: string, Page_Categorie_Nom?: string, Page_Categorie_Description?: string, Page_Categorie_Article?: Array<any>, Page_Categorie_Page?: Array<any>, Page_Categorie_Children?: Array<any>, Page_Categorie_SUPCategorieId?: string, Page_Categorie_Parent_CategorieId?: string, Page_Categorie_Parent_Nom?: string, Page_Categorie_Parent_Description?: string, Page_Categorie_Parent_Article?: Array<any>, Page_Categorie_Parent_Page?: Array<any>, Page_Categorie_Parent_Children?: Array<any>, Page_Categorie_Parent_SUPCategorieId?: string, Page_Categorie_Parent_Parent?: { [key: string]: string; }, Page_Categorie_Parent_UtilisateurCreation?: string, Page_Categorie_Parent_UtilisateurModification?: string, Page_Categorie_Parent_DateCreation?: Date, Page_Categorie_Parent_DateModification?: Date, Page_Categorie_UtilisateurCreation?: string, Page_Categorie_UtilisateurModification?: string, Page_Categorie_DateCreation?: Date, Page_Categorie_DateModification?: Date, Page_Modele_Id?: string, Page_Modele_Name?: string, Page_Modele_NbTitre?: number, Page_Modele_NbParagraphe?: number, Page_Modele_NbImage?: number, Page_Modele_UtilisateurCreation?: string, Page_Modele_UtilisateurModification?: string, Page_Modele_DateCreation?: Date, Page_Modele_DateModification?: Date, Page_estPublie?: boolean, Page_Formulaire?: Array<any>, Page_Titres?: Array<any>, Page_Paragraphes?: Array<any>, Page_Fichiers?: Array<any>, Page_UtilisateurCreation?: string, Page_UtilisateurModification?: string, Page_DateCreation?: Date, Page_DateModification?: Date, PageId?: string, UtilisateurCreation?: string, UtilisateurModification?: string, DateCreation?: Date, DateModification?: Date, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public put(id: string, Email: string, FormulaireId?: string, Nom?: string, Prenom?: string, NumeroTel?: string, Entreprise?: string, Fonction?: string, Objet?: string, Message?: string, Page_PageId?: string, Page_Resume?: string, Page_Ordre?: string, Page_Categorie_CategorieId?: string, Page_Categorie_Nom?: string, Page_Categorie_Description?: string, Page_Categorie_Article?: Array<any>, Page_Categorie_Page?: Array<any>, Page_Categorie_Children?: Array<any>, Page_Categorie_SUPCategorieId?: string, Page_Categorie_Parent_CategorieId?: string, Page_Categorie_Parent_Nom?: string, Page_Categorie_Parent_Description?: string, Page_Categorie_Parent_Article?: Array<any>, Page_Categorie_Parent_Page?: Array<any>, Page_Categorie_Parent_Children?: Array<any>, Page_Categorie_Parent_SUPCategorieId?: string, Page_Categorie_Parent_Parent?: { [key: string]: string; }, Page_Categorie_Parent_UtilisateurCreation?: string, Page_Categorie_Parent_UtilisateurModification?: string, Page_Categorie_Parent_DateCreation?: Date, Page_Categorie_Parent_DateModification?: Date, Page_Categorie_UtilisateurCreation?: string, Page_Categorie_UtilisateurModification?: string, Page_Categorie_DateCreation?: Date, Page_Categorie_DateModification?: Date, Page_Modele_Id?: string, Page_Modele_Name?: string, Page_Modele_NbTitre?: number, Page_Modele_NbParagraphe?: number, Page_Modele_NbImage?: number, Page_Modele_UtilisateurCreation?: string, Page_Modele_UtilisateurModification?: string, Page_Modele_DateCreation?: Date, Page_Modele_DateModification?: Date, Page_estPublie?: boolean, Page_Formulaire?: Array<any>, Page_Titres?: Array<any>, Page_Paragraphes?: Array<any>, Page_Fichiers?: Array<any>, Page_UtilisateurCreation?: string, Page_UtilisateurModification?: string, Page_DateCreation?: Date, Page_DateModification?: Date, PageId?: string, UtilisateurCreation?: string, UtilisateurModification?: string, DateCreation?: Date, DateModification?: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public put(id: string, Email: string, FormulaireId?: string, Nom?: string, Prenom?: string, NumeroTel?: string, Entreprise?: string, Fonction?: string, Objet?: string, Message?: string, Page_PageId?: string, Page_Resume?: string, Page_Ordre?: string, Page_Categorie_CategorieId?: string, Page_Categorie_Nom?: string, Page_Categorie_Description?: string, Page_Categorie_Article?: Array<any>, Page_Categorie_Page?: Array<any>, Page_Categorie_Children?: Array<any>, Page_Categorie_SUPCategorieId?: string, Page_Categorie_Parent_CategorieId?: string, Page_Categorie_Parent_Nom?: string, Page_Categorie_Parent_Description?: string, Page_Categorie_Parent_Article?: Array<any>, Page_Categorie_Parent_Page?: Array<any>, Page_Categorie_Parent_Children?: Array<any>, Page_Categorie_Parent_SUPCategorieId?: string, Page_Categorie_Parent_Parent?: { [key: string]: string; }, Page_Categorie_Parent_UtilisateurCreation?: string, Page_Categorie_Parent_UtilisateurModification?: string, Page_Categorie_Parent_DateCreation?: Date, Page_Categorie_Parent_DateModification?: Date, Page_Categorie_UtilisateurCreation?: string, Page_Categorie_UtilisateurModification?: string, Page_Categorie_DateCreation?: Date, Page_Categorie_DateModification?: Date, Page_Modele_Id?: string, Page_Modele_Name?: string, Page_Modele_NbTitre?: number, Page_Modele_NbParagraphe?: number, Page_Modele_NbImage?: number, Page_Modele_UtilisateurCreation?: string, Page_Modele_UtilisateurModification?: string, Page_Modele_DateCreation?: Date, Page_Modele_DateModification?: Date, Page_estPublie?: boolean, Page_Formulaire?: Array<any>, Page_Titres?: Array<any>, Page_Paragraphes?: Array<any>, Page_Fichiers?: Array<any>, Page_UtilisateurCreation?: string, Page_UtilisateurModification?: string, Page_DateCreation?: Date, Page_DateModification?: Date, PageId?: string, UtilisateurCreation?: string, UtilisateurModification?: string, DateCreation?: Date, DateModification?: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public put(id: string, Email: string, FormulaireId?: string, Nom?: string, Prenom?: string, NumeroTel?: string, Entreprise?: string, Fonction?: string, Objet?: string, Message?: string, Page_PageId?: string, Page_Resume?: string, Page_Ordre?: string, Page_Categorie_CategorieId?: string, Page_Categorie_Nom?: string, Page_Categorie_Description?: string, Page_Categorie_Article?: Array<any>, Page_Categorie_Page?: Array<any>, Page_Categorie_Children?: Array<any>, Page_Categorie_SUPCategorieId?: string, Page_Categorie_Parent_CategorieId?: string, Page_Categorie_Parent_Nom?: string, Page_Categorie_Parent_Description?: string, Page_Categorie_Parent_Article?: Array<any>, Page_Categorie_Parent_Page?: Array<any>, Page_Categorie_Parent_Children?: Array<any>, Page_Categorie_Parent_SUPCategorieId?: string, Page_Categorie_Parent_Parent?: { [key: string]: string; }, Page_Categorie_Parent_UtilisateurCreation?: string, Page_Categorie_Parent_UtilisateurModification?: string, Page_Categorie_Parent_DateCreation?: Date, Page_Categorie_Parent_DateModification?: Date, Page_Categorie_UtilisateurCreation?: string, Page_Categorie_UtilisateurModification?: string, Page_Categorie_DateCreation?: Date, Page_Categorie_DateModification?: Date, Page_Modele_Id?: string, Page_Modele_Name?: string, Page_Modele_NbTitre?: number, Page_Modele_NbParagraphe?: number, Page_Modele_NbImage?: number, Page_Modele_UtilisateurCreation?: string, Page_Modele_UtilisateurModification?: string, Page_Modele_DateCreation?: Date, Page_Modele_DateModification?: Date, Page_estPublie?: boolean, Page_Formulaire?: Array<any>, Page_Titres?: Array<any>, Page_Paragraphes?: Array<any>, Page_Fichiers?: Array<any>, Page_UtilisateurCreation?: string, Page_UtilisateurModification?: string, Page_DateCreation?: Date, Page_DateModification?: Date, PageId?: string, UtilisateurCreation?: string, UtilisateurModification?: string, DateCreation?: Date, DateModification?: Date, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling put.');
        }

        if (Email === null || Email === undefined) {
            throw new Error('Required parameter Email was null or undefined when calling put.');
        }


























































        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (FormulaireId !== undefined && FormulaireId !== null) {
            queryParameters = queryParameters.set('FormulaireId', <any>FormulaireId);
        }
        if (Nom !== undefined && Nom !== null) {
            queryParameters = queryParameters.set('Nom', <any>Nom);
        }
        if (Prenom !== undefined && Prenom !== null) {
            queryParameters = queryParameters.set('Prenom', <any>Prenom);
        }
        if (Email !== undefined && Email !== null) {
            queryParameters = queryParameters.set('Email', <any>Email);
        }
        if (NumeroTel !== undefined && NumeroTel !== null) {
            queryParameters = queryParameters.set('NumeroTel', <any>NumeroTel);
        }
        if (Entreprise !== undefined && Entreprise !== null) {
            queryParameters = queryParameters.set('Entreprise', <any>Entreprise);
        }
        if (Fonction !== undefined && Fonction !== null) {
            queryParameters = queryParameters.set('Fonction', <any>Fonction);
        }
        if (Objet !== undefined && Objet !== null) {
            queryParameters = queryParameters.set('Objet', <any>Objet);
        }
        if (Message !== undefined && Message !== null) {
            queryParameters = queryParameters.set('Message', <any>Message);
        }
        if (Page_PageId !== undefined && Page_PageId !== null) {
            queryParameters = queryParameters.set('Page.PageId', <any>Page_PageId);
        }
        if (Page_Resume !== undefined && Page_Resume !== null) {
            queryParameters = queryParameters.set('Page.Resume', <any>Page_Resume);
        }
        if (Page_Ordre !== undefined && Page_Ordre !== null) {
            queryParameters = queryParameters.set('Page.Ordre', <any>Page_Ordre);
        }
        if (Page_Categorie_CategorieId !== undefined && Page_Categorie_CategorieId !== null) {
            queryParameters = queryParameters.set('Page.Categorie.CategorieId', <any>Page_Categorie_CategorieId);
        }
        if (Page_Categorie_Nom !== undefined && Page_Categorie_Nom !== null) {
            queryParameters = queryParameters.set('Page.Categorie.Nom', <any>Page_Categorie_Nom);
        }
        if (Page_Categorie_Description !== undefined && Page_Categorie_Description !== null) {
            queryParameters = queryParameters.set('Page.Categorie.Description', <any>Page_Categorie_Description);
        }
        if (Page_Categorie_Article) {
            Page_Categorie_Article.forEach((element) => {
                queryParameters = queryParameters.append('Page.Categorie.Article', <any>element);
            })
        }
        if (Page_Categorie_Page) {
            Page_Categorie_Page.forEach((element) => {
                queryParameters = queryParameters.append('Page.Categorie.Page', <any>element);
            })
        }
        if (Page_Categorie_Children) {
            Page_Categorie_Children.forEach((element) => {
                queryParameters = queryParameters.append('Page.Categorie.Children', <any>element);
            })
        }
        if (Page_Categorie_SUPCategorieId !== undefined && Page_Categorie_SUPCategorieId !== null) {
            queryParameters = queryParameters.set('Page.Categorie.SUPCategorieId', <any>Page_Categorie_SUPCategorieId);
        }
        if (Page_Categorie_Parent_CategorieId !== undefined && Page_Categorie_Parent_CategorieId !== null) {
            queryParameters = queryParameters.set('Page.Categorie.Parent.CategorieId', <any>Page_Categorie_Parent_CategorieId);
        }
        if (Page_Categorie_Parent_Nom !== undefined && Page_Categorie_Parent_Nom !== null) {
            queryParameters = queryParameters.set('Page.Categorie.Parent.Nom', <any>Page_Categorie_Parent_Nom);
        }
        if (Page_Categorie_Parent_Description !== undefined && Page_Categorie_Parent_Description !== null) {
            queryParameters = queryParameters.set('Page.Categorie.Parent.Description', <any>Page_Categorie_Parent_Description);
        }
        if (Page_Categorie_Parent_Article) {
            Page_Categorie_Parent_Article.forEach((element) => {
                queryParameters = queryParameters.append('Page.Categorie.Parent.Article', <any>element);
            })
        }
        if (Page_Categorie_Parent_Page) {
            Page_Categorie_Parent_Page.forEach((element) => {
                queryParameters = queryParameters.append('Page.Categorie.Parent.Page', <any>element);
            })
        }
        if (Page_Categorie_Parent_Children) {
            Page_Categorie_Parent_Children.forEach((element) => {
                queryParameters = queryParameters.append('Page.Categorie.Parent.Children', <any>element);
            })
        }
        if (Page_Categorie_Parent_SUPCategorieId !== undefined && Page_Categorie_Parent_SUPCategorieId !== null) {
            queryParameters = queryParameters.set('Page.Categorie.Parent.SUPCategorieId', <any>Page_Categorie_Parent_SUPCategorieId);
        }
        if (Page_Categorie_Parent_Parent !== undefined && Page_Categorie_Parent_Parent !== null) {
            queryParameters = queryParameters.set('Page.Categorie.Parent.Parent', <any>Page_Categorie_Parent_Parent);
        }
        if (Page_Categorie_Parent_UtilisateurCreation !== undefined && Page_Categorie_Parent_UtilisateurCreation !== null) {
            queryParameters = queryParameters.set('Page.Categorie.Parent.UtilisateurCreation', <any>Page_Categorie_Parent_UtilisateurCreation);
        }
        if (Page_Categorie_Parent_UtilisateurModification !== undefined && Page_Categorie_Parent_UtilisateurModification !== null) {
            queryParameters = queryParameters.set('Page.Categorie.Parent.UtilisateurModification', <any>Page_Categorie_Parent_UtilisateurModification);
        }
        if (Page_Categorie_Parent_DateCreation !== undefined && Page_Categorie_Parent_DateCreation !== null) {
            queryParameters = queryParameters.set('Page.Categorie.Parent.DateCreation', <any>Page_Categorie_Parent_DateCreation.toISOString());
        }
        if (Page_Categorie_Parent_DateModification !== undefined && Page_Categorie_Parent_DateModification !== null) {
            queryParameters = queryParameters.set('Page.Categorie.Parent.DateModification', <any>Page_Categorie_Parent_DateModification.toISOString());
        }
        if (Page_Categorie_UtilisateurCreation !== undefined && Page_Categorie_UtilisateurCreation !== null) {
            queryParameters = queryParameters.set('Page.Categorie.UtilisateurCreation', <any>Page_Categorie_UtilisateurCreation);
        }
        if (Page_Categorie_UtilisateurModification !== undefined && Page_Categorie_UtilisateurModification !== null) {
            queryParameters = queryParameters.set('Page.Categorie.UtilisateurModification', <any>Page_Categorie_UtilisateurModification);
        }
        if (Page_Categorie_DateCreation !== undefined && Page_Categorie_DateCreation !== null) {
            queryParameters = queryParameters.set('Page.Categorie.DateCreation', <any>Page_Categorie_DateCreation.toISOString());
        }
        if (Page_Categorie_DateModification !== undefined && Page_Categorie_DateModification !== null) {
            queryParameters = queryParameters.set('Page.Categorie.DateModification', <any>Page_Categorie_DateModification.toISOString());
        }
        if (Page_Modele_Id !== undefined && Page_Modele_Id !== null) {
            queryParameters = queryParameters.set('Page.Modele.Id', <any>Page_Modele_Id);
        }
        if (Page_Modele_Name !== undefined && Page_Modele_Name !== null) {
            queryParameters = queryParameters.set('Page.Modele.Name', <any>Page_Modele_Name);
        }
        if (Page_Modele_NbTitre !== undefined && Page_Modele_NbTitre !== null) {
            queryParameters = queryParameters.set('Page.Modele.NbTitre', <any>Page_Modele_NbTitre);
        }
        if (Page_Modele_NbParagraphe !== undefined && Page_Modele_NbParagraphe !== null) {
            queryParameters = queryParameters.set('Page.Modele.NbParagraphe', <any>Page_Modele_NbParagraphe);
        }
        if (Page_Modele_NbImage !== undefined && Page_Modele_NbImage !== null) {
            queryParameters = queryParameters.set('Page.Modele.NbImage', <any>Page_Modele_NbImage);
        }
        if (Page_Modele_UtilisateurCreation !== undefined && Page_Modele_UtilisateurCreation !== null) {
            queryParameters = queryParameters.set('Page.Modele.UtilisateurCreation', <any>Page_Modele_UtilisateurCreation);
        }
        if (Page_Modele_UtilisateurModification !== undefined && Page_Modele_UtilisateurModification !== null) {
            queryParameters = queryParameters.set('Page.Modele.UtilisateurModification', <any>Page_Modele_UtilisateurModification);
        }
        if (Page_Modele_DateCreation !== undefined && Page_Modele_DateCreation !== null) {
            queryParameters = queryParameters.set('Page.Modele.DateCreation', <any>Page_Modele_DateCreation.toISOString());
        }
        if (Page_Modele_DateModification !== undefined && Page_Modele_DateModification !== null) {
            queryParameters = queryParameters.set('Page.Modele.DateModification', <any>Page_Modele_DateModification.toISOString());
        }
        if (Page_estPublie !== undefined && Page_estPublie !== null) {
            queryParameters = queryParameters.set('Page.estPublie', <any>Page_estPublie);
        }
        if (Page_Formulaire) {
            Page_Formulaire.forEach((element) => {
                queryParameters = queryParameters.append('Page.Formulaire', <any>element);
            })
        }
        if (Page_Titres) {
            Page_Titres.forEach((element) => {
                queryParameters = queryParameters.append('Page.Titres', <any>element);
            })
        }
        if (Page_Paragraphes) {
            Page_Paragraphes.forEach((element) => {
                queryParameters = queryParameters.append('Page.Paragraphes', <any>element);
            })
        }
        if (Page_Fichiers) {
            Page_Fichiers.forEach((element) => {
                queryParameters = queryParameters.append('Page.Fichiers', <any>element);
            })
        }
        if (Page_UtilisateurCreation !== undefined && Page_UtilisateurCreation !== null) {
            queryParameters = queryParameters.set('Page.UtilisateurCreation', <any>Page_UtilisateurCreation);
        }
        if (Page_UtilisateurModification !== undefined && Page_UtilisateurModification !== null) {
            queryParameters = queryParameters.set('Page.UtilisateurModification', <any>Page_UtilisateurModification);
        }
        if (Page_DateCreation !== undefined && Page_DateCreation !== null) {
            queryParameters = queryParameters.set('Page.DateCreation', <any>Page_DateCreation.toISOString());
        }
        if (Page_DateModification !== undefined && Page_DateModification !== null) {
            queryParameters = queryParameters.set('Page.DateModification', <any>Page_DateModification.toISOString());
        }
        if (PageId !== undefined && PageId !== null) {
            queryParameters = queryParameters.set('PageId', <any>PageId);
        }
        if (UtilisateurCreation !== undefined && UtilisateurCreation !== null) {
            queryParameters = queryParameters.set('UtilisateurCreation', <any>UtilisateurCreation);
        }
        if (UtilisateurModification !== undefined && UtilisateurModification !== null) {
            queryParameters = queryParameters.set('UtilisateurModification', <any>UtilisateurModification);
        }
        if (DateCreation !== undefined && DateCreation !== null) {
            queryParameters = queryParameters.set('DateCreation', <any>DateCreation.toISOString());
        }
        if (DateModification !== undefined && DateModification !== null) {
            queryParameters = queryParameters.set('DateModification', <any>DateModification.toISOString());
        }

        let headers = this.defaultHeaders;

        var token: string ='Bearer '+ localStorage.getItem('MyApp_token').replace(/\"/gi,'');
        if (token != undefined) {
            headers = headers.set('Authorization', token);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.put<any>(`${this.basePath}/api/formulaire/${encodeURIComponent(String(id))}`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
